@import "../../../../../global/theme/breakpoints";
@import "../../../../../../../../node_modules/overlayscrollbars/styles/overlayscrollbars.css";


$search-results-border-radius: rem(0.5);
$searchInputHeightDark: rem(2.25);
$searchInputHeightLight: rem(2.625);

:host([data-mode='default']) {
  --ds-search-results-height: #{$searchInputHeightDark};
}

:host([data-mode='light']) {
  --ds-search-results-height: #{$searchInputHeightLight};
}

:host(:not([type="menu"]))::before {
  position: absolute;
  inset-inline: 0;
  inset-block-start: calc(var(--ds-search-results-height) / 2);
  box-sizing: border-box;
  width: 100%;
  height: calc(var(--ds-search-results-height) / 2);
  background-color: var(--cxsShell_Active_SearchBackground);
  content: "";
  border-inline: var(--ds-search-input-border);
  z-index: calc(var(--cxs-popover-z-index, 1000) - 1);
}

.search-fly-out {
  box-sizing: border-box;
  width: 100%;
  padding-block-start: rem(1);
  background-color: var(--cxsShell_Active_SearchBackground);

  ::slotted(&__title) {
    padding-block: rem(1);
    padding-inline: var(--cxs-spacer-s);
    color: var(--cxsShell_SearchPlaceholderColor);
    font: var(--cxsShell_MenuHeadingFont);
    text-transform: uppercase;
  }

  ::slotted(&__empty-message) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    block-size: rem(7.625);
    color: var(--cxsShell_SearchPlaceholderColor);
    font: var(--cxsShell_SearchFont);
  }

  ::slotted(&__loading-indicator) {
    display: flex;
    align-items: center;
    justify-content: center;
    block-size: rem(11.25);
  }

  ::slotted(&__error-message) {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    block-size: rem(11.25);
    padding-inline: var(--cxs-spacer-s);
  }

  &__scrollbar {
    .os-theme-dark.os-scrollbar {
      padding: 0;
    }

    .os-scrollbar-track {
      background-color: var(--cxsShell_Active_SearchBackground);
    }

    .os-scrollbar-handle {
      border: 4px solid var(--cxsShell_Active_SearchBackground);
    }
  }

  &--desktop {
    position: absolute;
    max-height: calc(var(--mobile-menu-height, 100vh) - var(--cxsShell_Height) - var(--ds-search-results-height) - rem(0.5));
    padding-block-start: 0;
    border: var(--ds-search-input-border);
    border-block-start: none;
    border-end-start-radius: $search-results-border-radius;
    border-end-end-radius: $search-results-border-radius;
    z-index: calc(var(--cxs-popover-z-index, 1000) - 1);

    .search-fly-out__scrollbar {
      max-height: calc(var(--mobile-menu-height, 100vh) - var(--cxsShell_Height) - var(--ds-search-results-height) - rem(0.5) - 1px);
      overflow-y: auto;
    }

    ::slotted(&__title) {
      padding-block: rem(1.5) var(--cxs-spacer-xs);
    }
  }

}
